import { type ReactNode } from 'react'

import { Subheader } from '@/components/common/Subheader/Subheader'
import { IconWithLabel } from '@/components/icons/IconWithLabel'
import { type IconType } from '@/defs/icon'
import { formatFullNumber } from '@/utils/formatUtil'

import { useGalleryDisplay } from '../GalleryDisplayProvider/GalleryDisplayProvider'
import { useGalleryGroups } from '../GalleryGroupsProvider/GalleryGroupsProvider'

import styles from './GallerySubheader.module.scss'

type Props = {
  children?: ReactNode
  icon?: IconType
  title?: string
  variant?: 'recs'
}

export const GallerySubheader = ({ children, icon = 'filter', title: titleProp = 'Filtered View', variant }: Props) => {
  const { cardFiltersCount } = useGalleryDisplay()
  const { filteredCount, groups, recsCount } = useGalleryGroups()

  const recsHidden = recsCount - filteredCount

  const hasFilters = cardFiltersCount > 0

  const title = hasFilters
    ? `${titleProp} (${formatFullNumber(cardFiltersCount)} active card filter${cardFiltersCount > 1 ? 's' : ''})`
    : titleProp

  if (variant === 'recs' && !hasFilters) return null

  return (
    <Subheader pushLeftDisabled={variant === 'recs' && groups.length > 1}>
      <IconWithLabel iconBefore={icon} wrapNone>
        <div className={styles.container}>
          <h2>{title}</h2>
          {cardFiltersCount > 0 && (
            <p>
              {formatFullNumber(filteredCount)} cards found ({formatFullNumber(recsHidden)} hidden)
            </p>
          )}
        </div>
      </IconWithLabel>
      {children}
    </Subheader>
  )
}
